export default __webpack_public_path__ + "static/media/2008.7a451262.png";